export default {
  namespaced: true,
  state: {
    showModal: false,
    showStateModal: false,
    stateModal: {
      title: 'Erro!',
      body: 'Não foi possível completar a operação',
      classe: 'modal-danger',
      icon: 'fa fa-times-circle',
      okButton: 'OK',
      okAction: null,
      okType: 'white',
      okOutline: false,
      closeBtnLabel: null,
      closeBtnType: 'link text-white',
    }
  },
  getters: {
    showModal: state => {
      return state.showModal
    },
    showStateModal: state => {
      return state.showStateModal
    },
    stateModal: state => {
      return state.stateModal
    }
  },
  actions: {
    toggleStateModal({ commit }) {
      return commit('toggleStateModal');
    },
    invokeStateModal({ commit }, payload) {
      commit('updateStateModal', payload);
      return commit('toggleStateModal');
    },
  },
  mutations: {
    toggleModal (state) {
      state.showModal = !state.showModal
    },
    updateStateModal(state, payload) {
      /*let copy = state.stateModal;
      Object.assign(copy, payload);
      state.stateModal = copy;*/
      state.stateModal = payload
    },
    toggleStateModal (state) {
      state.showStateModal = !state.showStateModal
    }
  }
};
